export default __webpack_public_path__ + "static/media/Microbusiness.b7d8bf58.png";